//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    dance: {
      default: "",
    },
    figure: {
      default: "",
    },
    step: {
      default: "",
    },
    role: {
      default: "Both",
    },
  },
  watch: {
    step(newStep, prevStep) {
      if (this.figure.stepsMan[0].LF) {
        this.prevStep = prevStep;
        this.updateFeet();
        console.log(`Step changed to ${this.step} from ${this.prevStep}`);
      } else {
        console.log("No step data");
      }
    },
  },
  data() {
    return {
      prevStep: "", //Used for determining if stepping forward or backwards
      showConfig: "false",
      ML: {
        x: 0,
        y: 0,
        rotation: 0,
        origin: "top",
        opacity: 1,
        transitionY: "transform 1s ease-in",
        transitionX: "transform 1s ease-in",
        transitionOther: "opacity 1s step-end",
        isStanding: false,
      },
      MR: {
        x: 0,
        y: 0,
        rotation: 0,
        origin: "top",
        opacity: 1,
        transitionY: "transform 1s ease-in",
        transitionX: "transform 1s ease-in",
        transitionOther: "opacity 1s step-end",
        isStanding: true,
      },
      LL: {
        x: 0,
        y: 0,
        rotation: 0,
        origin: "top",
        opacity: 1,
        transitionY: "transform 1s 0.1s ease-in",
        transitionX: "transform 1s 0.1s ease-in",
        transitionOther: "opacity 1s step-end",
        isStanding: true,
      },
      LR: {
        x: 0,
        y: 0,
        rotation: 0,
        origin: "top",
        opacity: 1,
        transitionY: "transform 1s 0.1s ease-in",
        transitionX: "transform 1s 0.1s ease-in",
        transitionOther: "opacity 1s step-end",
        isStanding: false,
      },
    };
  },
  computed: {
    facing() {
      return this.figure.startAlignment;
    },
    facingInDegrees() {
      switch (this.facing) {
        case "LOD":
          return 0;
        case "DC":
          return -45;
        case "C":
          return -90;
        case "BDC":
          return -135;
        case "BLOD":
          return 180;
        case "BDW":
          return 135;
        case "W":
          return 90;
        case "DW":
          return 45;
        default:
          return 0;
      }
    },
    groupFacing() {
      return {
        transform: `rotate(${this.facingInDegrees}deg)`,
      };
    },
  },
  methods: {
    updateFeet() {
      let man = this.figure.stepsMan[this.step];
      let lady = this.figure.stepsLady[this.step];
      let feet = [this.ML, this.MR, this.LL, this.LR];
      let data = [man.LF, man.RF, lady.LF, lady.RF];
      let trans = "transform 1s ease-in, opacity 1s step-end";

      for (let i = 0; i < 4; i++) {
        feet[i].x = data[i].x;
        feet[i].y = data[i].y;
        feet[i].rotation = data[i].rotation;
        feet[i].isStanding = data[i].isStanding;
        feet[i].origin = data[i].origin ? data[i].origin : "top";
        feet[i].transitionX = data[i].transitionX ? data[i].transitionX : trans;
        feet[i].transitionY = data[i].transitionY ? data[i].transitionY : trans;
        feet[i].transitionOther = data[i].transitionOther
          ? data[i].transitionOther
          : trans;
        if (this.prevStep > this.step) {
          feet[i].transitionX =
            feet[i].transitionY =
            feet[i].transitionOther =
              "all 0s";
        }
      }
    },
  },
  mounted() {
    if (this.figure.stepsMan[0].LF) {
      this.updateFeet();
    }
  },
};
